const ASSET_IMAGE_BASE_URL = "https://asset.modusj.com/image";

export const staticURL = (fileName: string): string =>
  `${ASSET_IMAGE_BASE_URL}/${fileName.replace(/^\/+/, "").replace(/^image\//, "")}`;

export const resolveImageUrl = (imageUrl: string): string => {
  const normalized = imageUrl.trim();
  if (/^(https?:|data:|blob:|\/\/)/i.test(normalized)) return normalized;
  return staticURL(normalized);
};
